<template>
    <layout title="Новое КП">
        <proforma-invoice-form
                :sets="sets.data"
                :companies="companies.data"></proforma-invoice-form>
    </layout>
</template>

<script>
import Layout from '~/Layouts/Layout'
import ProformaInvoiceForm from '~/Components/ProformaInvoice/ProformaInvoiceForm'

export default {
  components: {
    Layout,
    ProformaInvoiceForm
  },
  props: {
    sets: Object,
    companies: Object
  }
}
</script>
